// In production, nginx proxies /api/ to the shared Node server on
// localhost:3002 (same server the warehouse app uses), so reports go
// same-origin over HTTPS. In local dev (CRA on :3000) there is no proxy, so
// hit the Node server directly.
const ERROR_ENDPOINT =
  window.location.hostname === 'localhost'
    ? 'http://localhost:3002/api/error-report'
    : '/api/error-report';

// Do not attribute errors to legacy global identity. The diagnostic receiver
// lacks an authenticated profile/DB/actor contract; omit user metadata.

export function reportError(error, extra = {}) {
  try {
    const payload = {
      source: 'Vendor PWA',
      message: error?.message || String(error),
      stack: error?.stack,
      url: window.location.href,
      user: 'unknown',
      email: '',
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      ...extra,
    };

    navigator.sendBeacon(
      ERROR_ENDPOINT,
      new Blob([JSON.stringify(payload)], { type: 'application/json' })
    );
  } catch (_) {
    // Don't let error reporting cause more errors
  }
}

// Catch unhandled errors globally
window.addEventListener('error', (event) => {
  reportError(event.error || event.message, { type: 'unhandled' });
});

// Catch unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  reportError(event.reason || 'Unhandled promise rejection', { type: 'unhandledrejection' });
});
